import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { createEmptySpace } from '../../../api/api_spaces';
import { fetchUser } from '../../../api/api_users';

const NewSpace = () => {
    const { translations } = useLanguage();
    const [name, setName] = useState('');
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('userToken');
    
        const getUser = async () => {
            try {
                const response = await fetchUser(token);
                if (response && !response.error) {
                    setUser(response.data);
                } else {
                    console.error('Error fetching user:', response.message);
                    navigate('/login');
                }
            } catch (error) {
                console.error('Error fetching user:', error);
                navigate('/login');
            }
        };
    
        getUser();
    }, [navigate]);
    
    const handleAddSpace = async () => {
        const token = localStorage.getItem('userToken');
        try {
            if (!name) {
                alert(translations.please_enter_name_for_space);
                return;
            }
            if (!user) {
                alert(translations.user_data_not_available);
                navigate('/login');                
                return;
            }
            const newSpace = await createEmptySpace(name, token);
            if (newSpace && !newSpace.error) {
                alert(translations.space_added_successfully);
                navigate(-1);
            } else {
                alert(translations.failed_to_add_space);
            }
        } catch (error) {
            console.error(translations.error_adding_space + ':', error);
            alert(translations.error_adding_space);            
        }
    };

    const handleBack = () => {
        navigate(-1)
    }

    return (
        <div className="sm-page">
            <div className="sm-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.new_space}</h1>
                </div>
                <div className="content">
                    <input
                        type="text"
                        className="general-input"
                        value={name}
                        placeholder='Name'
                        onChange={(e) => setName(e.target.value)}
                    />
                    <button onClick={handleAddSpace} className="general-button">{translations.add_space}</button>
                </div>
            </div>
        </div>
    );
};

export default NewSpace;
